import { CustomerResponse } from "../../../types/customer.type";
import { featureAccess } from "../../../permissions/access";
import { useUserRole } from "../../../utils/hooks/useUserRole";
// import AddressInfo from "./AddressInfo";
import ContactInfo from "./ContactInfo";
import CustomerInfo from "./CustomerInfo";
import PrintSettingsSummary from "./PrintSettingsSummary";
import LineRegisterQr from "./LineRegisterQr";
import { canRegisterLine } from "../../../utils/lineRegister";

interface CustomerDetailsProps {
  customerDetails: CustomerResponse;
  onUpdated?: () => void;
}

export default function CustomerDetails({
  customerDetails,
  onUpdated,
}: CustomerDetailsProps) {
  // The print settings are read by the same approvers who configure them; the server refuses
  // the read to anyone else (marketing), and that 403 would replace the whole page.
  const canSeePrintSettings = featureAccess.printSettings(useUserRole());

  return (
    <>
      <CustomerInfo customerDetails={customerDetails} onUpdated={onUpdated} />
      <ContactInfo customerDetails={customerDetails} />
      {canRegisterLine(customerDetails.status) && (
        <LineRegisterQr customerDetails={customerDetails} />
      )}
      {canSeePrintSettings && (
        <PrintSettingsSummary customerDetails={customerDetails} />
      )}
      {/* <AddressInfo customerDetails={customerDetails} /> */}
    </>
  );
}
